import axios from "axios";
import store from '../index';
import ChatterFilter from "../../components/chatter/chat/ChatterFilter.vue";

export default {
  namespaced: true,
  state: {
    // 프로젝트 관련 데이터
    projectList: [], // 추가
    allProjectInfo: '', // 23-07-12 추가
    allProjectRoles: [], // 23-08-11 추가 프로젝트 role 설정 시 자동완성을 위한 전체 프로젝트 role 목록
    //금일 휴가인 사람들의 userId 목록(MeMo List에서 금일 휴가인 Assignee를 표시하기 위함)
    todayOffUserIdList: [],
    // Chatter 관련 데이터
    total: 0,
    chats: [],  // 이미 조회한 Chatter 목록
    duplicatedChatCount: 0,
    /**
     * occupied
     *
     * Chatter Status Board가 이미 Chatter List를 사용하고 있음을 나타내는 플래그.
     * Chatter List 리로드 시 filter를 무시하도록 구현되어 있음.
     * TODO 추후 기능 개선 필요
     * @author Jiwon Yoon 2023-08-17
     */
    occupied: false,
    filterOccupied : false,
    //ChatterList.vue 에서 현재 검색하고 있는 조건 보이기 위한 라벨
    searchOptionsLabel:"",
    notifications: [],
    filter: {
      projectId: "",
      status: "",
      assignee: "",
      keyword: "",
      keywordWithComment: false,
      queryId: null,
      queryTitle: "",
      query: "",
      queryOrderBy:"",
      updated: "",
      withClosedProjects: false,
      hierarchy : true,
      retrieveType : "FILTER",
      sort: [],
      page: 1,
      pageSize: 10,
    },
    statusDashboardFilter:{
      project: {
        text: 'All Projects',
        value: '',
      },
      status: '',
      subStatus: '',
      assignee: {
        text: 'All Assignee',
        value: '',
      } 
    },
    searchDetailInfo:{
      title:"",
      query:"",
      queryOrderBy:"",
    },
    chatterListRefresh: false,
    //Chatter 페이지에 있는 toggle 정보 저장(create 되어도 상태 유지하기 위함)
    pageInfo:{
      toggle:{
        //Filter의 Search Detail
        filterSearchDetail:false,
        //Filter의 Without Closed Projects 토글 여부
        filterClosedProjects:false,
        //table info 버튼
        filterInfo:false
      }
    },
    options: {
      statusOptions: [
        //status: text에서 빈칸 없는 값(chatter filter에서 사용하기 위함)
        {value: "OPEN", text: "Open", status:"Open", disabled: false, update: false},
        {
          value: "ACTIVE",
          text: "\u00A0\u00A0\u00A0\u00A0\u00A0Active",
          status:"Active",
          disabled: false,
          update: false,
        }, // ACTIVE 는 현재 TO_DO + IN_PROGRESS
        {
          value: "TO_DO",
          text: "\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0To Do",
          status:"To Do",
          disabled: false,
          update: true,
        },
        {
          value: "IN_PROGRESS",
          text: "\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0In Progress",
          status:"In Progress",
          disabled: false,
          update: true,
        },
        {
          value: "DONE",
          text: "\u00A0\u00A0\u00A0\u00A0\u00A0Done",
          status:"Done",
          disabled: false,
          update: true,
        },
        {
          value: "CANCELLED",
          text: "\u00A0\u00A0\u00A0\u00A0\u00A0Cancelled",
          status:"Cancelled",
          disabled: false,
          update: true,
        },
        {value: "CLOSED", text: "Closed", status:"Closed", disabled: false, update: true},
      ],
      assigneeOptions: [],
      //모든 User List
      assignees: [],
      projectOptions: [],
      /* 기존에는 데이터가 숫자값으로 저장되고, 현재는 문자열로 저장되고 있음. 혹시 남아있는 데이터가 있을 수 있으므로 주석 삭제 X */
      // levelOptions: [
      //   {value: "", text: ""},
      //   {value: "3", text: "Critical"},
      //   {value: "2", text: "Major"},
      //   {value: "1", text: "Minor"},
      //   {value: "0", text: "Trivial"},
      // ],
      // jobOptions: [
      //   {value: "", text: ""},
      //   {value: "10", text: "기획"},
      //   {value: "9", text: "디자인"},
      //   {value: "8", text: "Publishing"},
      //   {value: "7", text: "설계"},
      //   {value: "6", text: "Front End"},
      //   {value: "5", text: "Back End"},
      //   {value: "4", text: "Database"},
      //   {value: "3", text: "Batch"},
      //   {value: "2", text: "Interface"},
      //   {value: "1", text: "문서 작성"},
      //   {value: "0", text: "기타"},
      // ],
      // priorityOptions: [
      //   {value: "", text: ""},
      //   {value: "2", text: "High"},
      //   {value: "1", text: "Medium"},
      //   {value: "0", text: "Low"},
      // ],
      levelOptions: ["", "Critical", "Major", "Minor", "Trivial"],
      typeOptions: [
        {value: "", text: " "},
        {value: "task", text: "Task"},
        {value: "issue", text: "Issue"},
        {value: "risk", text: "Risk"},
        {value: "bug", text: "Bug"},
        {value: "inquiry", text: "Inquiry"},
        {value: "archive", text: "Archive"},
        // {value: "requirement", text: "Requirement"},
      ],
      priorityOptions: ["", "High", "Medium", "Low"],
      importanceOptions: ["", "High", "Medium", "Low"],
      // ----------------------------
      // TODO 아래 2개 옵션은 Project 설정에서 가져올 예정
      //businessCategoryOptions: [""],
      systemOptions: [""],
      // ----------------------------
      resultOptions: ["", "Success", "Fail"],
      jobOptions: [
        "",
        "기획",
        "디자인", 
        "Publishing",
        "설계", 
        "Front End", 
        "Back End",
        "Database",
        "Batch",
        "Interface",
        "문서 작성",
        "기타"
      ],

      projectStatusOptions: [
        // {value: "", text: ""},
        {value: "OPEN", text: "Open", disabled: false, update: false},
        {value: "CLOSED", text: "Closed", disabled: false, update: true},
      ],
      fieldOptions: [
        {value: "", text: "--choose field--", disabled: true},
        {value: "Project", text: "Project", type: "var"},
        {value: "Status", text: "Status", type: "var"},
        {value: "Assignee", text: "Assignee", type: "var"},
      ],
      operatorOptions: [
        {type: "var", valType: "", value: "", text: "--oper--", disabled: true},
        {type: "var", valType: "select", value: "is", text: "is"},
        {type: "var", valType: "select", value: "is not", text: "is not", disabled: true},
        {type: "var", valType: "", value: "is empty", text: "is empty", disabled: true},
        {type: "var", valType: "", value: "is not empty", text: "is not empty", disabled: true},
        {type: "var", valType: "input", value: "starts with", text: "starts with", disabled: true},
        {type: "var", valType: "input", value: "ends with", text: "ends with", disabled: true},
        {type: "var", valType: "input", value: "contains", text: "contains", disabled: true},
        {type: "var", valType: "input", value: "does not contain", text: "does not contain", disabled: true},
        {type: "var", valType: "", value: "is anything", text: "is anything", disabled: true},
        {type: "var", valType: "", value: "is same", text: "is same", disabled: true},
        {type: "var", valType: "", value: "is different", text: "is different", disabled: true},
        {type: "var", valType: "", value: "is empty string", text: "is empty string", disabled: true},
      ],
      allMethodologyOptions:[],

    },
    user : {},
    chatStatus: {
      todo: {
        overdue: [],
        scheduled: [],
        tbd: [],
        today: []
      },
      inProgress: {
        overdue: [],
        scheduled: [],
        tbd: [],
        today: []
      },
      completed: {
        done: [],
        cancelled: [],
        closed: [],
        confirmed: []
      }
    },
  },
  getters: {
    chats(state) {
      return state.chats;
    },
    total(state) {
      return state.total;
    },
    occupied(state) {
      return state.occupied;
    },
    filterOccupied(state){
      return state.filterOccupied;
    },
    filter(state) {
      return state.filter;
    },
    options(state) {
      return state.options;
    },
    statusOptions(state) {
      return state.options.statusOptions;
    },
    assigneeOptions(state) {
      return state.options.assigneeOptions;
    },
    assignees(state) {
      return state.options.assignees;
    },
    projectOptions(state) {
      return state.options.projectOptions;
    },
    priorityOptions(state) {
      return state.options.priorityOptions;
    },
    importanceOptions(state) {
      return state.options.importanceOptions;
    },
    businessCategoryOptions: (state) => (projectId) => {
      let businessCategoryOptions = state.allProjectInfo.filter(obj => obj.projectId === projectId);
      //해당 project가 business category를 가지면 business catgeory 목록 반환
      return businessCategoryOptions.length > 0 ? [ {text: '', value: ''}, ...businessCategoryOptions[0].businessCategory] : [];
    },
    systemOptions(state) {
      return state.options.systemOptions;
    },
    resultOptions(state) {
      return state.options.resultOptions;
    },
    levelOptions(state) {
      return state.options.levelOptions;
    },
    typeOptions(state) {
      return state.options.typeOptions;
    },
    fieldOptions(state) {
      return state.options.fieldOptions;
    },
    operatorOptions(state) {
      return state.options.operatorOptions;
    },
    valueOptions(state) {
      return state.options.valueOptions;
    },
    jobOptions(state) {
      return state.options.jobOptions;
    },
    projectStatusOptions(state) {
      return state.options.projectStatusOptions;
    },
    getProjectList(state) {
      return state.projectList;
    },
    getNotifications(state) {
      return state.notifications;
    },
    getNotificationCount(state) {
      return state.notifications.length;
    },
    getAllProjectInfo(state) {
      return state.allProjectInfo;
    },
    getUpdated(state) {
      return state.filter.updated;
    },
    statusDashboardFilter(state){
      return state.statusDashboardFilter;
    },
    getAllMethodologyOptions(state){
      return state.options.allMethodologyOptions;
    },
    // statusBarProjectName(state){
    //   return state.statusBar.projectName;
    // },
    toggle(state){
      return state.pageInfo.toggle;
    },
    searchOptionsLabel(state){
      return state.searchOptionsLabel;
    },
    todayOffUserIdList(state){
      return state.todayOffUserIdList;
    },
    chatterListRefresh(state) {
      return state.chatterListRefresh;
    },
    getUserByUserId: (state) => (userId) => {
      let returnAssigneeObj = {
        profileImg: require('@/assets/images/icon_user.png'),
        profileImgName: 'default',
        profileImgPath: '',
        text: 'unknown',
        value: '',
        userId: '',
        userName: 'unknown',
      }
      const assignee = state.options.assignees;
      for (let i = 0; i < assignee.length; i++) {
        if (assignee[i].userId === userId) {

          const user = assignee[i];
          if (user) { 
            returnAssigneeObj = {...user};
            if (!returnAssigneeObj.profileImg) {
              returnAssigneeObj.profileImg = require('@/assets/images/icon_user.png');
            } else if (!returnAssigneeObj.profileImg.startsWith('data:image/')) {
              returnAssigneeObj.profileImg = 'data:image/' + returnAssigneeObj.profileImg.substr(returnAssigneeObj.profileImg.lastIndexOf('.')) + ';base64,' + returnAssigneeObj.profileImg;
            }
          }
        }
      }
      return returnAssigneeObj;
    },
    getSummaryCount(state){
      return state.chatStatus;
    }
  },
  actions: {
    async getNotifications({commit}) {
      try {
        const response = await axios.get("chatter/notifications", {
          headers: {
            Authorization: accessToken(),
            Accept: "application/json"
          }
        });
        commit('setNotifications', response.data);
      } catch (error) {
        console.log(error);
      }
    },
    // 23-10-11 컴포넌트 로드 시 매번 수행하던 아래 로직 Top Bar에서 단 한번만 수행하도록 변경 retrieveAssigneeOptions
    // async retrieveProjectOptions({commit}) {
    //   let response = await axios.post(
    //     "chatter/retrieveProjectList",
    //     {},
    //     {headers: {Authorization: accessToken()}}
    //   );
    //   commit("setProjectOptions", response.data);
    // },
    async retrieveAssigneeOptions({commit}) {
      let response = await axios.get('chatter/retrieveChattererList', {
        headers: {Authorization: accessToken()}
      })
      commit("setAssigneeOptions", response.data);
      commit("setAssignees", response.data);
    },
    async retrieveAllProjectInfo(context, option) {
      if (!option && option != 'update') {
        if(context.state.allProjectInfo) return;
      }

      let response = await axios.get('chatter/retrieveAllProjectInfo', {
        headers: {Authorization: accessToken()}
      });

      //title,assignee,description은 일단 필수 요소이므로 여기서 모든 프로젝트 config에 추가함
      context.commit('setAllProjectInfo',response.data.projectInfo.filter(
        project => project.config.push({option:'assignee', isMandatory:true}, {option:'title', isMandatory:true}, {option:'description', isMandatory:true})
        )
      );
      context.commit('setAllProjectRoles', response.data.roles);
      // Project Options 세팅
      context.commit('setProjectOptions', response.data.projectInfo);
    },
    synchronizeChatData(context, {chatId, subordinate}) {
      const params = {};
      params['chatIdList'] = [chatId];
      
      params['hierarchy'] = false;
      params['pageSize'] = 0;

      try {
        axios.post('chatter/retrieveChatterList',
          params,
        {
          headers:{Authorization: accessToken()}
        }).then(response => {
          const status = response.data.status;

          if(status === "200") {
            let body = response.data.body;
            if(body.list.length === 1) {
              body.list[0].changeSubordinate = subordinate;

              // 생성, 수정 된 Chatter가 Filter의 조건에 맞을 때
              // console.log('필터 조건 충족');
              context.commit('setChat', body.list[0]);

              // if(chatId.subordinate !== undefined){
              //   context.commit('changeSubordinate', chatId.subordinate);
              // }
            } else if (body.list.length < 1) {
              // 생성, 수정 된 Chatter가 Filter의 조건에 맞지 않을 때
              // console.log('필터링');
              context.commit('removeChat', chatId);
            }
          }
        })
      } catch (e) {
        console.log(e);
      }
    },
    
    async reloadChats(context) {
      try {
        let response = await axios.post('/chatter/retrieveChatterList',
          context.state.filter,
          { headers: { Authorization: accessToken() } }
        );

        const status = response.data.status;

        if (status === "200") {
          const body = response.data.body;
          body.list.forEach(item => item.isExpanded = false);
          context.commit('resetChats');
          context.commit('setChats', body.list);
          context.commit('setTotal', body.total);
        }
        // chats 갱신
        // total 갱신
      } catch(e) {
        console.log(e);
      }
    }
  },
  mutations: {
    setChats(state, chats) {
      let duplicatedChatCount = 0;
      chats.forEach(chat => {
        // 이미 있는 chat이면 상태업데이트
        const idx = state.chats.findIndex(prevChat => prevChat.chatId === chat.chatId);
        // 몾찾으면 push
        if(idx < 0) {
          // 없는 chat이면 추가
          state.chats.push(chat)
        } else {
          // 이미 있으면 최신으로 업데이트
          state.chats[idx] = chat;
          duplicatedChatCount += 1;
        }
      })
      state.duplicatedChatCount += duplicatedChatCount;
    },
    setChat(state, newChat) {
      let idx = state.chats.findIndex(chat => chat.chatId === newChat.chatId);

      // 새로운 chat일 때
      if(idx === -1) {
        state.chats.unshift(newChat);
        state.total += 1;
      } else { // 수정된 chat일 때
        let prevChatState = state.chats[idx];
        prevChatState.projectId = newChat.projectId;
        prevChatState.status = newChat.status;
        prevChatState.title = newChat.title;
        prevChatState.priority = newChat.priority;
        prevChatState.startDate = newChat.startDate;
        prevChatState.dueDate = newChat.dueDate;
        prevChatState.businessCategory = newChat.businessCategory;
        prevChatState.assignee = newChat.assignee;
        prevChatState.userName = newChat.userName;
        prevChatState.unread = newChat.unread;
        prevChatState.updated = newChat.updated;
        prevChatState.changeSubordinate = newChat.changeSubordinate;
      }
    },
    /** 사용자가 Chatter를 읽었을 때 Vuex에 있는 Chatter라면 상태 변화
     * (updated, unread)
     * @param {*} state 
     * @param {*} chatId 
     */
    readChat(state, chatId) {
      let readChat = state.chats.find(chat => chat.chatId === chatId);
      const currentUser = store.getters['auth/currentUser'];
      
      // vuex에 없는 Chatter면 리턴
      if(readChat === undefined) return;

      readChat.updated = false;
      // Assignee와 Caller가 같을 때 읽음 처리
      if(readChat.assignee === currentUser.caller) {
        readChat.unread = false;
      }
    },
    removeChat(state, chatId) {
      let idx = state.chats.findIndex(chat => chat.chatId === chatId);

      if(idx !== -1) {
        state.chats.splice(idx, 1);
        state.total -= 1;
      }
    },
    setTotal(state, total) {
      state.total = total - state.duplicatedChatCount;
    },
    incrementPage(state) {
      state.filter.page += 1;
    },
    setPage(state, page) {
      state.filter.page = page;
    },
    setRetrieveType(state, type) {
      state.filter.retrieveType = type;
    },
    setOccupied(state, occupied) {
      state.occupied = occupied;
    },
    setFilterOccupied(state, occupied){
      state.filterOccupied = occupied;
    },
    setProjectList(state, data) {
      state.projectList = data;
    },
    setProjectOptions(state, data) {
      // 자신이 속한 프로젝트만 options에 저장
      // 추후 admin role에 대해 모든 프로젝트를 볼 수 있도록 로직 추가 예상

      const currentUser = store.getters['auth/currentUser'];

      let containsCurrentUserProjectArray = data.filter(project => {
        project.text = project.name;
        project.value = project.projectId;
        for(let projectUser of project.projectUserList) {
          if(projectUser.userId === currentUser.caller) {
            return project;
          }
        }
      });
      state.options.projectOptions = containsCurrentUserProjectArray.sort((a, b) => {
        return a.text.localeCompare(b.text);
      });
    },
    setAssigneeOptions(state, data) {
      data.forEach(object => {
        object.value = object.userId;
        object.text = `${object.userName} (${object.userId})`;
      });
      state.options.assigneeOptions = data.sort((a, b) => {
        return a.text.localeCompare( b.text);
      });
    },
    // 2023-12-14 Yunji Kim
    /* 기존에는 Vuex의 options을 이용해서 Vuex에서 assigneeOptions를 {text: '', value:''} 형태로 변경했음.
       이 로직을 Vuex에서 분리하고, View는 Vuex에서는 필요한 데이터만 가져오고 조작은 View에서 하기 위해서 아래와 같이 로직을 수정함.
    */
    setAssignees(state, data){
      state.options.assignees = data.sort((a, b) => {
        return a.text.localeCompare(b.text);
      });
    },
    mergeNotifications(state, data) {
      // 23-10-10 웹소켓으로 받은 데이터를 바로 대입했더니 
      // 웹소켓 데이터 도착시기에 따라서 과거의 DB데이터가 덮어씌워지는 버그가 생김
      // 기존 가지고 있던 데이터와 받은 데이터를 합친 후 중복을 제거하는 방법으로 변경
      // state.notifications = data;

      // 배열 합치기
      let mergedNotificationsArr = [...state.notifications, ...data];

      // Set으로 변경하여 중복제거
      let uniqueNotificationsSet = new Set(mergedNotificationsArr);

      // 사용하기 쉽게 Set을 다시 배열로 변경
      state.notifications = [...uniqueNotificationsSet];
    },
    setNotifications(state, data) {
      state.notifications = data;
    },
    removeNotifications(state, data) {
      let index = state.notifications.indexOf(data);

      // 알림에 존재하면 삭제
      if(index != -1) {
        state.notifications.splice(index, 1);
      }
    },
    setAllProjectInfo(state, data) {
      state.allProjectInfo = data;
    },
    setAllProjectRoles(state, data) {
      state.allProjectRoles = data;
    },
    setUpdated(state, data) {
      state.filter.updated = data;
    },
    setQueryId(state,data){
      state.filter.queryId=data;
    },
    setQueryTitle(state,data){
      state.filter.queryTitle=data;
    },
    setQuery(state, data) {
      state.filter.query = data;
    },
    setQueryOrderBy(state, data) {
      state.filter.queryOrderBy = data;
    },
    setSort(state, columns) {
      state.filter.sort = columns
        .filter(col => col.sort)
        .map(col => ({
          colName: col.colName,
          sort: col.sort
        }))
    },
    chatterListRefresh(state) {
      state.chatterListRefresh = !state.chatterListRefresh;
    },
    resetChats(state) {
      state.chats = [];
      state.duplicatedChatCount = 0;
    },
    resetFilter(state) {
      state.filter = {
        projectId: "",
        status: "",
        assignee: "",
        keyword: "",
        keywordWithComment: false,
        queryId:null,
        queryTitle:"",
        query: "",
        queryOrderBy:"",
        updated: "",
        sort: [],
        hierarchy: true,
        withClosedProjects: false,   
        retrieveType: "FILTER",
        page: 1,
        pageSize: 10,
      };
    },
    setStatusDashboardFilterProjectId(state,data){
      state.statusDashboardFilter.project = data;
    },
    setStatusDashboardFilterStatus(state,data){
      state.statusDashboardFilter.status = data;
    },
    setStatusDashboardFilterSubStatus(state, data) {
      state.statusDashboardFilter.subStatus = data;
    },
    setStatusDashboardFilterAssignee(state, data) {
      state.statusDashboardFilter.assignee = data;
    },
    setAllMethodologyOptions(state,data){
      state.options.allMethodologyOptions = data;
    },
    resetStatusDashboardFilter(state) {

      const defaultAssigneeOption = {
        text: 'All Assignee', value: '',
      }

      // 현재 사용자 정보 가져오기
      const currentUser = store.getters['auth/currentUser'];
      if(currentUser != null) {
        defaultAssigneeOption.text = currentUser.userkorname;
        defaultAssigneeOption.value = currentUser.caller;
      }
    
      state.statusDashboardFilter={
        project: {text: 'All Projects', value: ''},
        status: '',
        subStatus: '',
        assignee: defaultAssigneeOption,
      }
    },
    setFilterProjectId(state, data){
      state.filter.projectId=data;
    },
    resetQuery(state){
      state.filter.queryId=null;
      state.filter.queryTitle="";
      state.filter.query="";
      state.filter.queryOrderBy="";
    },
    setToggleFilterSearchDetail(state,data){
      state.pageInfo.toggle.filterSearchDetail=data;
    },
    setToggleFilterClosedProjects(state,data){
      state.pageInfo.toggle.filterClosedProjects=data;
    },
    setToggleFilterInfo(state,data){
      state.pageInfo.toggle.filterInfo=data;
    },
    setFilterAssignee(state,data){
      state.filter.assignee=data;
    },
    setSearchOptionsLabel(state,data){
      state.searchOptionsLabel=data;
    },
    setTodayOffUserIdList(state,data){
      state.todayOffUserIdList = data;
    },
    updateUserDetails(state, userDetails) {
    // 사용자 정보 업데이트
    state.userDetails = userDetails;
    }
  },
};